
const routes_names = ["", "documentation", "encrypt", "decrypt"]
export const routes = 
{
    home: `/${routes_names[0]}`,
    encrypt: `/${routes_names[2]}`,
    decrypt: `/${routes_names[3]}`,
    doc: `/${routes_names[1]}`
}

export const version = "0.1.4"


